namespace advisorop.components.widgets {

    export class AddressFormController {
        usCountryCode = 'US';
        address: domains.IAddress = {};
        countries: domains.ILOV[] = [];
        states: domains.ILOV[] = [];
        selCountry: domains.ILOV;
        selState: domains.ILOV;
        StateFormat = domains.StateFormat;
        
        // event, when any address data has been changed
        addressChanged: any;

        set typeState(value: boolean) {
            this.address.stateFormat = value ? domains.StateFormat.RAW_TEXT : domains.StateFormat.TWO_DIGIT_CODE;
        } get typeState(): boolean {
            return this.address && (this.address.stateFormat == domains.StateFormat.RAW_TEXT);
        }

        static $inject = ["generalService"];
        constructor(private gs: services.GeneralService) {
        }
        
        loadCountries(): ng.IPromise<any> {
            return this.gs.getLOVs()
                .then(data => this.countries =
                    data
                    .filter(v => v.lovType === domains.LovType.COUNTRIES && v.extra2 === this.usCountryCode)
                    .concat(data.filter(v => v.lovType === domains.LovType.COUNTRIES && v.extra2 !== this.usCountryCode))
                , err => toastr.warning("Countries can not be loaded. Please try to refresh this page"));
        }

        loadStates(): ng.IPromise<any> {
            return this.gs.getLOVs()
                .then(data => this.states = data.filter(f => f.lovType == domains.LovType.STATES)
                , error => toastr.warning("Countries has not been loaded. Please try to refresh this page"));
        }

        selectCountry(): void {
            //console.log("selecting country", this.address);
            if (!(this.address && this.address.country && this.address.country.length > 0)) {
                //this will be default country
                this.selCountry = this.countries.filter(f => f.extra2 == this.usCountryCode)[0];
                //console.log("selecting country", this.address, "Selected country: ", this.selCountry, this.countries);
                if (this.selCountry)
                    this.address.country = this.selCountry.extra2;
                else
                    this.address.country = null;
            } else if (this.address) {
                this.selCountry = this.countries.filter(f => f.name == this.address.country)[0];
                if (this.selCountry)
                    this.address.country = this.selCountry.extra2;
                else
                    this.address.country = null;
            }
            else
                this.selCountry = null;
        }

        selectState(): void {
            if (this.address && this.address.state && this.address.state.length > 0) {
                this.selState = this.states.filter(f => f.extra1 == this.address.state)[0];
                if (this.selState)
                    this.address.state = this.selState.extra1;
            } else {
                this.selState = null;
            }
        }

        onDataChanged(): void
        {
            if (this.selCountry) {
                this.address.country = this.selCountry.name;
            } else {
                this.address.country = null;
            }

            if (this.selState) {
                this.address.state = this.selState.extra1;
            } else {
                this.address.state = null;
            }

            //console.log("onDataChanged: ", this.address);
            this.addressChanged({ address: this.address });
        }
        
        $onInit() {
            //console.log("Address initialising...");
            this.loadCountries().then(data => this.selectCountry());
            this.loadStates().then(data => this.selectState());
        }
        
        $onChanges(evt): void {
            for (var key in evt) {
                if (key === "address") {
                    //console.log("Address has been changed. ", this.address);
                    this.selectCountry();
                    this.selectState();
                }
            }
        }
        
        $routerOnActivate(next, previous) {
        }
    }

    class AddressForm implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                address: "<",
                addressChanged:"&"
            };
            this.controller = AddressController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/shared/common/address-form.html';
        }
    }
    angular.module(Constants.APP).component("addressForm", new AddressForm());

}